import { api } from 'app/app.api';

import {
  CreateApiTokenApiArg,
  CreateApiTokenApiResponse,
  CreateApiTokenWithScopesApiArg,
  CreateApiTokenWithScopesApiResponse,
  DeleteApiTokenApiArg,
  DeleteApiTokenApiResponse,
  ReadApiTokensWithScopesApiResponse,
  ReadOAuthProviderConnectionByIdArg,
  ReadOAuthProviderConnectionByIdResponse,
  ReadOAuthProviderConnectionStatusByIdArg,
  ReadOAuthProviderConnectionStatusByIdResponse,
  UpdateApiTokenScopesApiArg,
  UpdateApiTokenScopesApiResponse,
} from './types/authApi.types';

export const authApi = api
  .enhanceEndpoints({ addTagTypes: ['ApiTokens'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      readOAuthProviderConnectionById: builder.query<
        ReadOAuthProviderConnectionByIdResponse,
        ReadOAuthProviderConnectionByIdArg
      >({
        query: ({ id }) => ({
          type: 'partnerIntegrations',
          path: `auth/provider/connect/${id}`,
        }),
      }),
      readOAuthProviderConnectionStatusById: builder.query<
        ReadOAuthProviderConnectionStatusByIdResponse,
        ReadOAuthProviderConnectionStatusByIdArg
      >({
        query: ({ id }) => ({
          type: 'partnerIntegrations',
          path: `auth/provider/status/${id}`,
        }),
      }),
      readApiTokensWithScopes: builder.query<
        ReadApiTokensWithScopesApiResponse,
        void
      >({
        query: () => ({
          version: 1,
          path: 'auth/api-tokens-v2',
        }),
        providesTags: [{ type: 'ApiTokens', id: 'LIST' }],
      }),
      createApiToken: builder.mutation<
        CreateApiTokenApiResponse,
        CreateApiTokenApiArg
      >({
        query: ({ name, scopes, version }) => ({
          version: 1,
          method: 'POST',
          path: version === '2' ? 'auth/api-tokens-v2' : 'auth/api-tokens',
          body: { name, scopes, version },
        }),
        invalidatesTags: (_result, error) =>
          error ? [] : [{ type: 'ApiTokens', id: 'LIST' }],
      }),
      createApiTokenWithScopes: builder.mutation<
        CreateApiTokenWithScopesApiResponse,
        CreateApiTokenWithScopesApiArg
      >({
        query: ({ name, scopes }) => ({
          version: 1,
          method: 'POST',
          path: 'auth/api-tokens-v3',
          body: { name, scopes },
        }),
        invalidatesTags: (_result, error) =>
          error ? [] : [{ type: 'ApiTokens', id: 'LIST' }],
      }),
      updateApiTokenScopes: builder.mutation<
        UpdateApiTokenScopesApiResponse,
        UpdateApiTokenScopesApiArg
      >({
        query: ({ tokenId, scopeAdditions, scopeDeletions }) => ({
          version: 1,
          method: 'PATCH',
          path: `auth/api-tokens/${tokenId}/scopes`,
          body: {
            scope_additions: scopeAdditions,
            scope_deletions: scopeDeletions,
          },
        }),
        invalidatesTags: (_result, error) =>
          error ? [] : [{ type: 'ApiTokens', id: 'LIST' }],
      }),
      deleteApiToken: builder.mutation<
        DeleteApiTokenApiResponse,
        DeleteApiTokenApiArg
      >({
        query: ({ tokenId }) => ({
          version: 1,
          method: 'DELETE',
          path: `auth/api-tokens/${tokenId}`,
        }),
        invalidatesTags: (_result, error) =>
          error ? [] : [{ type: 'ApiTokens', id: 'LIST' }],
      }),
    }),
  });
